var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaths = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Real-Estate-Market-Calculator-Building--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Real Estate Market Calculator Building Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.69 2.54 -6 -2.5A0.5 0.5 0 0 0 17 0.5V14a0.5 0.5 0 0 0 0.5 0.5h1a0.5 0.5 0 0 0 0.5 -0.5v-2a0.5 0.5 0 0 1 0.5 -0.5h2a0.5 0.5 0 0 1 0.5 0.5v2a0.5 0.5 0 0 0 0.5 0.5h1a0.5 0.5 0 0 0 0.5 -0.5V3a0.5 0.5 0 0 0 -0.31 -0.46ZM22 8h-3a0.5 0.5 0 0 1 0 -1h3a0.5 0.5 0 0 1 0 1Zm0 -2.5h-3a0.5 0.5 0 0 1 0 -1h3a0.5 0.5 0 0 1 0 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.28 2.05 -5 2.5A0.51 0.51 0 0 0 10 5v2.5a0.5 0.5 0 0 0 0.5 0.5H13a4 4 0 0 1 2.22 0.69 0.5 0.5 0 0 0 0.78 -0.42V2.5a0.5 0.5 0 0 0 -0.72 -0.45ZM14 6.5h-2a0.5 0.5 0 0 1 0 -1h2a0.5 0.5 0 0 1 0 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9H3a3 3 0 0 0 -3 3v9a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-9a3 3 0 0 0 -3 -3ZM5.49 19.93l0.35 0.35a0.75 0.75 0 0 1 0 1.06 0.75 0.75 0 0 1 -1.06 0L4.43 21a0.25 0.25 0 0 0 -0.36 0l-0.35 0.35a0.75 0.75 0 0 1 -1.06 0 0.75 0.75 0 0 1 0 -1.06l0.34 -0.36a0.25 0.25 0 0 0 0 -0.36l-0.35 -0.35a0.75 0.75 0 1 1 1.06 -1.06l0.35 0.35a0.25 0.25 0 0 0 0.36 0l0.35 -0.35a0.75 0.75 0 1 1 1.06 1.06l-0.35 0.35a0.25 0.25 0 0 0 0.01 0.36ZM5.75 14h-0.5a0.25 0.25 0 0 0 -0.25 0.25v0.5a0.75 0.75 0 0 1 -1.5 0v-0.5a0.25 0.25 0 0 0 -0.25 -0.25h-0.5a0.75 0.75 0 0 1 0 -1.5h0.5a0.25 0.25 0 0 0 0.25 -0.25v-0.5a0.75 0.75 0 0 1 1.5 0v0.5a0.25 0.25 0 0 0 0.25 0.25h0.5a0.75 0.75 0 0 1 0 1.5Zm7.5 7.5h-3a0.75 0.75 0 0 1 0 -1.5h3a0.75 0.75 0 0 1 0 1.5Zm0 -2.5h-3a0.75 0.75 0 0 1 0 -1.5h3a0.75 0.75 0 0 1 0 1.5Zm0 -5h-3a0.75 0.75 0 0 1 0 -1.5h3a0.75 0.75 0 0 1 0 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaths);
export default ForwardRef;